<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired, validRangeDate } from '@/common/elementValid.js';
import userSearch from '@/components/tools/userSearch';
import task from '@/backend/services/task/task.js';

function getFormData(_obj, vm) {
	return {
		appointor: {
			label: '姓名',
			formType: userSearch,
			value: '',
			rules: [validRequired('请选择服务人员')],
		},
	};
}

async function submit(data) {
	try {
		let { attributes } = this;
		let { tableRow } = attributes;
		let idList = tableRow.map(item => item.id);
    await task.batchAppoint({
      idList,
      ...data
    })
		this.$message.success('修改成功');
    this.formData.loading = false;
		this.$emit('confirm');
	} catch (error) {
		this.$message.success('修改失败');
		this.formData.loading = false;
	}
}

function cancel(self) {
	self.$emit('cancel');
}

async function onShowLoad(obj) {
	return obj;
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '60px',
	}
);

export default formDialogCreate({
	name: 'batchAppointForm',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
